// extracted by mini-css-extract-plugin
module.exports = {"notice":"styles__notice___1AWQO","notice__primary-message":"styles__notice__primary-message___2fowI","notice__secondary-message":"styles__notice__secondary-message___9iXjp"};